import React from "react";
import { useTranslation } from "@helpers/translate";
import closeAllImage from "@assets/images/futures-modals/close-all.jpg";
import { ConfirmTradeModal } from "./ConfirmTradeModal";
import { CONFIRM_SKIP_FLAG } from "./constants";

/**
 * "Close all open trades?" — confirms closing every open trade
 * (docs/trade-logic.md 4.3 Close All).
 *
 * @param {object} props
 * @param {boolean} props.isOpen
 * @param {() => void} props.onClose
 * @param {() => Promise<void> | void} props.onConfirm closes all trades
 */
export const CloseAllModal = ({ isOpen, onClose, onConfirm }) => {
  const { __ } = useTranslation();

  return (
    <ConfirmTradeModal
      isOpen={isOpen}
      onClose={onClose}
      onConfirm={onConfirm}
      image={closeAllImage}
      title={__("futures.close_all_modal.title")}
      text={__("futures.close_all_modal.text")}
      confirmLabel={__("futures.close_all_modal.confirm")}
      cancelLabel={__("futures.close_all_modal.cancel")}
      skipFlag={CONFIRM_SKIP_FLAG.CLOSE_ALL}
    />
  );
};
